import useTranslation from "next-translate/useTranslation"
import styled from "styled-components"
import NiceModal from "@ebay/nice-modal-react"
import { PrimaryButtonLink } from "@hornet-web-react/core/components/UI/TextButton"
import SlideModal from "@hornet-web-react/core/components/Modals/SlideModal"
import { ModalContentCard } from "@hornet-web-react/core/components/UI/ContentCard"
import Trans from "next-translate/Trans"
import HornetAnalyticsEvent from "../../models/hornet-analytics-event"
import { useEventTrackerService } from "../../hooks/use-event-tracker-service"
import { useEmberAppUrl } from "../../hooks/use-ember-app-url"

const i18nKey = "hornet:components.modals.beta_info_modal"

const BetaInfoModal = NiceModal.create(() => {
  const { t } = useTranslation()
  const modal = NiceModal.useModal()
  const { reportEvent } = useEventTrackerService()
  const emberAppUrl = useEmberAppUrl()

  const leaveBetaUrl = `${emberAppUrl}/beta?leave=1&utm_campaign=beta&utm_source=betainfo&utm_medium=web`
  const reportFeedbackUrl = `${emberAppUrl}/contributors/forms/report-bug?utm_campaign=beta&utm_source=betainfo&utm_medium=web`

  const closeAction = {
    label: t(`${i18nKey}.close_button`),
    onClick: () => modal.hide(),
  }

  const handleLeaveBetaOnClick = (event) => {
    event.stopPropagation()
    event.preventDefault()

    const reportAndRedirect = async () => {
      reportEvent(HornetAnalyticsEvent.webTapOnLeaveBeta())

      window.location.href = leaveBetaUrl
    }

    void reportAndRedirect()
  }

  return (
    <SlideModal
      title={t(`${i18nKey}.title`)}
      isOpen={modal.visible}
      closeAction={closeAction}
      isCustom={true}
    >
      <ModalContentCard>
        <ModalContentCard.Content>
          <Content>
            <Heading>{t(`${i18nKey}.heading`)}</Heading>
            <Paragraph>
              <Trans
                i18nKey={`${i18nKey}.text1`}
                components={[
                  /* eslint-disable-next-line react/jsx-key */
                  <a
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    href={reportFeedbackUrl}
                  />,
                ]}
              />
            </Paragraph>
            <PrimaryButtonLink
              size={"small"}
              href={reportFeedbackUrl}
              target={"_blank"}
            >
              {t(`${i18nKey}.report_button`)}
            </PrimaryButtonLink>
          </Content>
        </ModalContentCard.Content>
        <SecondParagraph>
          <Trans
            i18nKey={`${i18nKey}.text2`}
            components={[
              /* eslint-disable-next-line react/jsx-key */
              <a
                rel={"noopener noreferrer"}
                onClick={handleLeaveBetaOnClick}
                href={leaveBetaUrl}
              />,
            ]}
          />
        </SecondParagraph>
      </ModalContentCard>
    </SlideModal>
  )
})

export default BetaInfoModal

const Heading = styled.h2`
  ${({ theme }) => theme.font.bold.headline};
  color: ${({ theme }) => theme.color.text.primary};
  margin: 0 0 ${({ theme }) => theme.spacing.regular} 0;
`

const Paragraph = styled.p`
  color: ${({ theme }) => theme.color.text.secondary};
  margin: 0 0 ${({ theme }) => theme.spacing.regular} 0;
`

const SecondParagraph = styled.p`
  ${({ theme }) => theme.font.regular.footnote};
  color: ${({ theme }) => theme.color.text.tertiary};
  padding: ${({ theme }) => theme.spacing.regular};
  margin: 0;
`

const Content = styled.div`
  padding: ${({ theme }) => theme.spacing.regular};
`
